import mergeClasses from "glesys-controlpanel/modifiers/merge-classes";
import CostCompact from "glesys-controlpanel/components/cost/compact";

<template>
  <div class="flex items-center pt-3 border-gray-200 border-t -mb-2 mt-12 justify-end" {{mergeClasses}} ...attributes>
    <CostCompact @currency={{@currency}} @price={{@cost}} @discountedPrice={{@discountedPrice}} />
  </div>
</template>
